// extracted by mini-css-extract-plugin
export default {"container":"loader-vintage_container__PJTlA","over":"loader-vintage_over__8JKFZ"};